import { createContext, useContext, useState, useEffect } from "react";
import { I18N } from "./constants";

const LangCtx = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("lang") || "fr"; } catch { return "fr"; }
  });
  useEffect(() => { try { localStorage.setItem("lang", lang); } catch {} }, [lang]);
  const t = (k) => I18N[lang]?.[k] ?? k;
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export function useLang() {
  return useContext(LangCtx);
}
